import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
    width: 100%;
    padding: 0.75rem;
    height: 20.625rem;

    display: flex;
    flex-direction: column;
    overflow: hidden;

    border-radius: 0.75rem;
    background-color: #f8f8f9;
    border: 0.3rem solid #f8f8f9;

    @media (max-width: 1366px) {
        /* min-width: 20.625rem; */
        /* max-width: 20.625rem; */
    }

    @media (max-width: 768px) {
        max-width: 100%;
        height: auto;
        overflow: visible;
    }
`;

export const CardsScroll = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;

    ::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        flex-direction: row;
        flex-wrap: nowrap;
        overflow-y: hidden;
        overflow-x: scroll;
        gap: 0.75rem;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    justify-content: space-between;
`;

export const ViewAll = styled.a`
    gap: 0.5rem;
    display: flex;
    flex-direction: row; 
    align-items: center;
    
    cursor: pointer;
    
    > img {
        width: 1rem;
        height: auto;
        display: flex;
    }
    
    > P {
        cursor: pointer;
    }
`;

export const EventCard = styled.div`
    width: 100%;
    padding: 0.5rem 0.8rem;
    height:  ${(hasNotification) => hasNotification  === true ? "auto" : "100%"};

    display: flex;
    margin-bottom: 0.75rem;
    justify-content: center;
    align-items: ${(hasNotification) => hasNotification  === true ? "flex-start" : "center"};

    border-radius: 0.5rem;
    background-color: white;

    @media (max-width: 768px) {
        width: 85%;
        min-width: 85%;
        max-width: 85%;
        flex-shrink: 0;
        margin-bottom: 0;
    }
`;

export const EventInfo = styled.div`
    width: 100%;

    gap: 0.5rem;
    display: flex;
    align-items: start;
    flex-direction: column;
    justify-content: flex-start;
`;

export const EventNotFound = styled.div`
    width: 100%;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;
    }

    >p{
        text-align: center;
    }
`;

export const EventHeader = styled.div`
    width: 100%;
    display: flex; 
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const EventNotificator = styled.div`
    >p {
        font-size: 1.3rem;
        margin-bottom: 0.1rem;
        color: ${props => (props.isRead ? `${theme.colors.blue.Azul_link}`: "white")};
    }
`;

export const EventTitle = styled.h4`
    width: 100%;
    height: auto;
    
    margin: 0;
    display: -webkit-box;
    
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const EventDate = styled.span`
    color: #888;
    font-size: 0.55rem;
    letter-spacing: 0.1rem;
`;

export const EventText = styled.p`
    overflow: hidden;
    font-size: 0.875rem;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    color: ${theme.colors.gray.Cinza_2};

`;
